export var PLUGIN_CONTAINER_CLASSES = ['bottom center', 'center top', 'center right', 'center left', 'bottom right', 'bottom left', 'right top', 'left top'];
export var createPluginContainerElement = function createPluginContainerElement(containerClasses) {
  var containerDiv = jQuery("<div class=\"mapplugins\">\n            <div class=\"mappluginsContainer\">\n            <div class=\"mappluginsContent\"></div>\n            </div>\n        </div>");
  containerDiv.addClass(containerClasses);
  containerDiv.attr('data-location', containerClasses);
  return containerDiv;
};

// assumes jQuery is present and mapEl is a jQuery object to #mapdiv
export var generatePluginContainers = function generatePluginContainers(mapEl) {
  var bottomContainer = jQuery("\n        <div class=\"plugins-bottom\">\n        </div>\n    ");
  PLUGIN_CONTAINER_CLASSES.map(function (cssClasses) {
    return createPluginContainerElement(cssClasses);
  }).forEach(function (jQueryEl) {
    if (jQueryEl.hasClass('bottom')) {
      bottomContainer.append(jQueryEl);
    } else {
      mapEl.append(jQueryEl);
    }
  });
  mapEl.append(bottomContainer);
};